<form [formGroup]="additionalFieldsForm" class="well" (document:click)="f.close();">
    <div class="modal-body">
       <div class="row ">
          <!-- <div class="col-md-2">
             <label class="form-control-label">IM Date</label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="imDate" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="imDate" ngbDatepicker #a="ngbDatepicker"
                   (click)="a.toggle();">
                <button class="input-group-addon"
                   (click)="a.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Date_1
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="CreditRatingLetterDate_1" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="CreditRatingLetterDate_1" ngbDatepicker #b="ngbDatepicker"
                   (click)="b.toggle();">
                <button class="input-group-addon"
                   (click)="b.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Amount_1
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="CreditRatingLetterAmount_1" NcdCommaSeperatedNumber (keydown)="onlyNumber($event);"
                   class="form-control" formControlName="CreditRatingLetterAmount_1" type="text">
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Date_2
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="CreditRatingLetterDate_2" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="CreditRatingLetterDate_2" ngbDatepicker #c="ngbDatepicker"
                   (click)="c.toggle();">
                <button class="input-group-addon"
                   (click)="c.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Amount_2
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group">
                <input class="form-control" NcdCommaSeperatedNumber (keydown)="onlyNumber($event);"
                   formControlName="CreditRatingLetterAmount_2" id="CreditRatingLetterAmount_2" type="text">
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Date_3
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="CreditRatingLetterDate_3" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="CreditRatingLetterDate_3" ngbDatepicker #d="ngbDatepicker"
                   (click)="d.toggle();">
                <button class="input-group-addon"
                   (click)="d.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Amount_3
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="CreditRatingLetterAmount_3" NcdCommaSeperatedNumber (keydown)="onlyNumber($event);"
                   class="form-control" formControlName="CreditRatingLetterAmount_3" type="text">
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Date_4
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="CreditRatingLetterDate_4" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="CreditRatingLetterDate_4" ngbDatepicker #e="ngbDatepicker"
                   (click)="e.toggle();">
                <button class="input-group-addon"
                   (click)="e.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Credit Rating Letter Amount_4
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="CreditRatingLetterAmount_4" NcdCommaSeperatedNumber (keydown)="onlyNumber($event);"
                   class="form-control" formControlName="CreditRatingLetterAmount_4" type="text">
             </div>
          </div> -->
 
          <div class="col-md-2">
             <label class="form-control-label">Listing Date
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="ListingDate" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="ListingDate" ngbDatepicker #f="ngbDatepicker"
                   (click)="f.toggle();">
                <button class="input-group-addon"
                   (click)="f.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <!-- <div class="col-md-2">
             <label class="form-control-label">Debenture Trustee Agreement Date
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="DebentureTrusteeAgreementDate"
                   style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="DebentureTrusteeAgreementDate"
                   ngbDatepicker #g="ngbDatepicker"
                   (click)="g.toggle();">
                <button class="input-group-addon"
                   (click)="g.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Deed of Hypothecation Date
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="DeedOfHypothecationDate" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="DeedOfHypothecationDate" ngbDatepicker #h="ngbDatepicker"
                   (click)="h.toggle();">
                <button class="input-group-addon"
                   (click)="h.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Simple Mortgate Deed Number
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="SimpleMortgateDeedNumber" class="form-control" formControlName="SimpleMortgateDeedNumber"
                   type="text">
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Simple Mortgate Deed Date
             </label>
          </div>
 
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="SimpleMortgateDeedDate" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="SimpleMortgateDeedDate" ngbDatepicker #i="ngbDatepicker"
                   (click)="i.toggle();">
                <button class="input-group-addon"
                   (click)="i.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Debenture Trustee Consent Number
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="DebentureTrusteeConsentNumber" class="form-control"
                   formControlName="DebentureTrusteeConsentNumber" type="text">
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Debenture Trustee Consent Date
             </label>
          </div>
 
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="DebentureTrusteeConsentDate" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="DebentureTrusteeConsentDate" ngbDatepicker #j="ngbDatepicker"
                   (click)="j.toggle();">
                <button class="input-group-addon"
                   (click)="j.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
 
          <div class="col-md-2">
             <label class="form-control-label">Property Description
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="PropertyDescription" class="form-control" formControlName="PropertyDescription" type="text">
             </div>
          </div> -->
 
          <div class="col-md-2">
             <label class="form-control-label">Charge ID
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="ChargeID" class="form-control" formControlName="ChargeID" type="text">
             </div>
          </div>
 
          <!--  <div class="col-md-2">
             <label class="form-control-label">Date of Signing Approval Letter
             </label>
          </div>
 
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="DateOfSigningApprovalLetter" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="DateOfSigningApprovalLetter" ngbDatepicker #k="ngbDatepicker"
                   (click)="k.toggle();">
                <button class="input-group-addon"
                   (click)="k.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
 
          <div class="col-md-2">
             <label class="form-control-label">Date of Intimation to Stock Exchange
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="DateOfIntimationToStockExchange"
                   style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="DateOfIntimationToStockExchange"
                   ngbDatepicker #l="ngbDatepicker"
                   (click)="l.toggle();">
                <button class="input-group-addon"
                   (click)="l.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Allotment Letter Date
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="AllotmentLetterDate" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="AllotmentLetterDate" ngbDatepicker #m="ngbDatepicker"
                   (click)="m.toggle();">
                <button class="input-group-addon"
                   (click)="m.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Date of Master Creation Form CDSL / NSDL
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="DateOfMasterCreationFormCDSL_NSDL"
                   style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="DateOfMasterCreationFormCDSL_NSDL"
                   ngbDatepicker #n="ngbDatepicker"
                   (click)="n.toggle();">
                <button class="input-group-addon"
                   (click)="n.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div>
 
          <div class="col-md-2">
             <label class="form-control-label">Debenture Trust Deed Date
             </label>
          </div>
          <div class="col-md-4 form-group">
             <div class="input-group" (click)="$event.stopPropagation()">
                <input class="form-control" formControlName="DebentureTrustDeedDate" style="padding:6px;z-index: 0;"
                   placeholder="dd-mm-yyyy" name="DebentureTrustDeedDate" ngbDatepicker #o="ngbDatepicker"
                   (click)="o.toggle();">
                <button class="input-group-addon"
                   (click)="o.toggle();"
                   type="button">
                   <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
             </div>
          </div> -->
 
          <div class="col-md-2">
             <label class="form-control-label">Aggregate Amount
             </label>
          </div>
          <div class="col-md-4">
             <div class="form-group">
                <input id="AggregateAmount" class="form-control" NcdCommaSeperatedNumber
                   formControlName="AggregateAmount" type="text" readonly>
             </div>
          </div> 
 
 
 
       </div>
 
       <div class="row modal-header col-md-12" style="max-height: 50px;">
          <h6 style="text-align: center"><b>System Calculated</b> </h6>
       </div>
 
       <div formArrayName="dynamicFieldsArray"
          *ngFor="let MultiOption of issueDetails.MultiOption; let i = index;">
          <div [formGroupName]="i">
            
             <div class="col-md-12 clearfix panel-group panel panel-primary panel-highlighted">
                <h5><b><label> Option {{i + 1}} :</label></b></h5>
                <div class="row" style="margin-top: 5px;">
                   <div class="col-md-2">
                      <label class="form-control-label">Number of Debentures Issued
                      <span _ngcontent-c2="" style="color: red;">*</span></label>
                   </div>
                   <div class="col-md-4">
                      <div class="form-group">
                         <input id="NumberOfDebenturesIssued{{i}}" NcdCommaSeperatedNumber
                            (keyup)="calculateDrawnAmount($event, i, MultiOption);" (keydown)="onlyNumber($event)"
                            class="form-control" formControlName="NumberOfDebenturesIssued" type="text" required="required">
                      </div>
                   </div>
 
                   <div class="col-md-2">
                      <label class="form-control-label">Drawn Amount
                      <span _ngcontent-c2="" style="color: red;">*</span></label>
                   </div>
                   <div class="col-md-4">
                      <div class="form-group">
                         <input id="DrawnAmount{{i}}" class="form-control" NcdCommaSeperatedNumber
                            formControlName="DrawnAmount" type="text" readonly required="required">
                      </div>
                   </div>
 
                   <div class="col-md-2">
                      <label class="form-control-label">ISIN NO
                      <span _ngcontent-c2="" style="color: red;">*</span></label>
                   </div>
                   <div class="col-md-4">
                      <div class="form-group">
                         <input id="isinNO{{i}}" formControlName="isinNO" class="form-control" type="text" (keyup)="checkIsinNoValid($event, i)" required="required">
                         <span class="form-control-error-custom" id="{{'isIsinNoValid' + i }}"></span>
                      </div>
                   </div>
 
                   <div class="col-md-2">
                      <label class="form-control-label">Scrip Code
                      <span _ngcontent-c2="" style="color: red;">*</span></label>
                   </div>
                   <div class="col-md-4 form-group">
                      <div class="input-group">
                         <input class="form-control" formControlName="scripCode" id="scripCode{{i}}" type="text" required="required">
                      </div>
                   </div>
 
                   <div class="col-md-2">
                      <label class="form-control-label">Date of Corporate Action (for redemption) <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                   </div>               
                    <div class="col-md-4 form-group">
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" formControlName="dateOfCorporateAction" id="dateOfCorporateAction{{i}}"
                          style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfCorporateAction{{i}}"
                          ngbDatepicker #p="ngbDatepicker" (click)="p.toggle()" required="required">
                        <button class="input-group-addon" (click)="p.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                    </div>
 
                </div>
             </div>
 
          </div>
       </div>
 
       <div class="modal-footer col-md-12 col-sm-12 text-right form-group">
          <button type="Submit" class="btn-sm btn btn-primary" [disabled]="!additionalFieldsForm.valid || disabledOnClick" (click)="addAdditionalFields()"> Update
          </button>
       </div>
    </div>
 </form>